<template>
    <div class="page login">

        <div class="login-title">
            手机号登录
            <div class="desc">
                手机号主要用于识别身份信息、推送短信消息
            </div>
        </div>

        <div class="login-content">
            <van-cell-group :border="false">
                <van-field
                    class="content-box"
                    label-class="content-title"
                    label-width="50px"
                    round
                    :border="false"
                    v-model="tel"
                    label="+86"
                    @keyup="bankCardKeyup"
                    placeholder="请输入手机号"
                    maxlength="13"

                />
            </van-cell-group>
        </div>

        <div class="login-control">
            <van-button type="danger" @click="sendVerify()" color="#0FB7AD" round size="large">继续</van-button>
            <div class="login-control-footer">
                <van-checkbox v-model="checked" checked-color="#0FB7AD" icon-size="16px">请阅读并同意 <a href="/#/xy">用户协议</a>与<a href="/#/ys">隐私政策</a></van-checkbox>
            </div>
        </div>
    </div>
</template>

<script>

    import Interface from "@/util/interface"
    export default {
        name: 'home',
        data() {
            return {
                value: "",
                active: 1,
                banners:[],
                recommend:[],
                articles:[],
                tel:"",
                radio : 1,
                checked:true,
            }
        },
        methods: {
            fetch(scene) {
                if (scene === 'banner') {
                    Interface.getData('get',Interface.home).then((res)=>{
                        this.banners = res.data.banners
                        this.recommend = res.data.recommend
                        this.articles = res.data.articles
                    })
                }
            },
            bankCardKeyup(){
                this.tel = this.tel.replace(/\s/g,'')
                    .replace(/[^\d]/g,'')
                    .replace(/(\d{3})(?=\d)/,'$1 ')
                    .replace(/(\d{3}) (\d{4})(?=\d)/,'$1 $2 ')
            },
            sendVerify(){
                let phoneValue = this.tel;
                if (phoneValue === '') {
                    this.$toast.fail('请填入手机号');
                }else {
                    Interface.getData('get',Interface.user.send_verify, { mobile: phoneValue.replace(/ /g,"") })
                        .then(res => {
                            if (res.code !== -1) {
                                this.$router.push({
                                    name : 'send-verify',
                                    query: {tel:phoneValue}
                                })
                            }
                        })
                }
            }
        },
        created() {
            this.fetch('banner')
            Interface.getShareInfo(this,"","","")
        },
    }
</script>

<style lang="scss">
    @import "./index.scss";
</style>



// WEBPACK FOOTER //
// src/views/login/login/index.vue